module.exports = "<a content track-link=\"login_with_diff_user\" href=\"\" class=\"textLink\" ng-click=\"actions.onClick()\">{{ this.message }}</a>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/notYou/template.html
// module id = ../node_modules/xo-page-components/src/notYou/template.html
// module chunks = 0